/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_SavingInputs */

const en_case_saving = /** @type {(inputs: Case_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const pt_br2_case_saving = /** @type {(inputs: Case_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Case_SavingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_saving = /** @type {((inputs?: Case_SavingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_SavingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_saving(inputs)
	return pt_br2_case_saving(inputs)
});